var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"coupon-selector",attrs:{"filterable":"","value":_vm.couponCode,"placeholder":"เลือก Coupon"},on:{"input":_vm.handleChangeCoupon}},_vm._l((_vm.couponOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.textDiscount,"value":item.id}},[_vm._v(_vm._s(item.textDiscount)+"\n  ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b6b75f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/components/CouponSelect.vue
// module id = null
// module chunks = 